<template>
  <div v-if='loading'>
    <oil-form
        title='ИНФО О ТТН'
        :items='waybill'
        :keys='keys'
        :createForm='false'
        @AppendixId='changeAppendix'
        @EmpowermentId='changeEmpowerment'
        @OrderId='changeOrder'
        @VehicleTrailer1='changeVehicleTrailer1'
        @VehicleTrailer2='changeVehicleTrailer2'
        @TerminalId='changeTerminal'
        :formCallback='formCallback'
    >
      <template v-slot:header='{id}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-if='id' class=' mx-8' type='button' icon
                   @click="showMePdf('waybill/print',id)"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:ShipmentDate='{rules,input}'>
        <div class='parent'>
          <date-picker
              v-if='waybill.ShowShipmentDate'
              itemKey='ShipmentDate'
              :item='waybill'
              :keys='startDateKeys'
              :vInput='input'
              :attr='startDateKeys.attrs'
          />
          <v-text-field v-else
                        label='Дата ТТН'
                        v-model='waybill.ShipmentDescription'
                        outlined dense :disabled='!input.isEdit'
          />
          <v-checkbox class='absolute'
                      hide-details
                      :disabled='!input.isEdit'
                      v-model='waybill.ShowShipmentDate'
                      outlined
                      dense
          ></v-checkbox>
        </div>


      </template>
      <template v-slot:Buyer.Id='{rules,input}'>
        <v-autocomplete
            :items='buyers$'
            v-stream:keyup.native='searchCompany$'
            hide-no-data
            clearable
            :disabled='!input.isEdit'
            :rules='[...rules]'
            dense
            outlined
            :readonly='readonlySeller'
            @change='changeBuyer'
            hide-selected
            :value='waybill.Buyer.CompanyName'
            item-text='CompanyName'
            label='Выбрать покупателя'
            return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Contract.Id='{rules,input}'>
        <v-autocomplete
            :items='contracts$'
            v-stream:keyup.native='searchContract$'
            hide-no-data
            :rules='[...rules]'
            clearable
            :disabled='!input.isEdit'
            @change='changeContract'
            :readonly='readonlyContract'
            dense
            outlined
            :value='waybill.Contract.Number'
            hide-selected
            item-text='Number'
            label='Выбрать договор'
            return-object
        ></v-autocomplete>
      </template>

      <template v-slot:Appendix.Id='{input}'>

        <v-select
            label='Номер приложения'
            placeholder='Номер'
            item-text='Number'
            item-value='Id'
            :disabled='!input.isEdit'
            v-model='waybill.Appendix.Id'
            :items='appendixes'
            :readonly='readonlyProgram'
            outlined
            dense
            return-object
        >

        </v-select>


      </template>
      <template v-slot:Empowerment.Id='{input}'>

        <v-select
            label='Выбрать доверенность'
            item-text='Number'
            item-value='Id'
            :disabled='!input.isEdit'
            v-model='waybill.Empowerment.Id'
            :items='epowerments'
            :readonly='readonlyProcuration'
            outlined
            dense
            return-object
        >

        </v-select>


      </template>
      <template v-slot:Order.Id='{input}'>

        <v-select
            label='Выбрать заявку'
            item-text='Number'
            item-value='Id'
            :disabled='!input.isEdit'
            v-model='waybill.Order.Id'
            :items='orders'
            :readonly='readonlyOrder'
            outlined
            dense
            return-object
        >

        </v-select>


      </template>


      <template v-slot:NoTransport='{rules,input}'>
        <v-radio-group v-model='waybill.NoTransport' :disabled='!input.isEdit' class='py-0 my-0'>
          <v-radio label='с транспортом' :value='false' ></v-radio>
          <v-radio label='без транспорта' :value='true' ></v-radio>
        </v-radio-group>
      </template>

      <template v-slot:Vehicle.Volume='{rules,input}'>
        <v-autocomplete
            :class="waybill.NoTransport ? 'transport' : ''"
            :items='vehicles$'
            v-stream:keyup.native='searchVehicle$'
            hide-no-data
            v-model='waybill.Vehicle.Id'
            :rules='[...rules]'
            :disabled='!input.isEdit'
            clearable
            @change='changeVehicle'
            dense
            outlined
            hide-selected
            item-text='Volume'
            item-value='Id'
            label='Автомобиль'
            return-object
        >
          <template v-slot:item='{item}'>
            <template>
              <v-list-item-content>
                {{ item.Name }}: "{{ item.ModelRegistrationNumber }}"
                Литраж: "{{ item.Volume }}"
              </v-list-item-content>
            </template>
          </template>
          <template v-slot:prepend-inner>
            <oil-modal
                maxWidth='1024'
                mdiColor='blue'
                :persistent='false'
                mdiIcon='mdi-dump-truck'
            >
              <template v-slot:body='{dialog}'>
                <v-card>
                  <v-card-text>
                    <v-card-title>
                      {{ 'создать автомобиль'.toUpperCase() }}
                    </v-card-title>
                    <v-text-field v-model='vehicle.Name' outlined dense label='Название' />
                    <v-text-field v-model='vehicle.Model' outlined dense label='Модель' />
                    <v-text-field v-model='vehicle.ModelRegistrationNumber' outlined dense
                                  label='Гос. регистрационный номер авто' />
                    <v-text-field v-model='vehicle.Volume' outlined dense label='Литраж' />
                    <v-btn @click='saveVehicle(vehicle,dialog)' color='primary' class='mr-2'>Добавить</v-btn>
                    <v-btn text @click='dialog.value = false'>Закрыть</v-btn>
                  </v-card-text>
                </v-card>
              </template>
            </oil-modal>
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:Driver.Name='{rules,input}'>
        <v-autocomplete
            :class="waybill.NoTransport ? 'transport' : ''"
            :items='drivers$'
            v-stream:keyup.native='searchDriver$'
            hide-no-data
            v-model='waybill.Driver.Id'
            :rules='[...rules]'
            :disabled='!input.isEdit'
            clearable
            @change='changeDriver'
            dense
            outlined
            hide-selected
            item-text='Name'
            item-value='Id'
            label='Водитель'
            return-object
        >
          <template v-slot:prepend-inner>
            <oil-modal
                maxWidth='800'
                mdiColor='blue'
                :persistent='false'
                mdiIcon='mdi-transit-transfer'
            >
              <template v-slot:body='{dialog}'>
                <v-card>
                  <v-card-text>
                    <v-card-title>
                      {{ 'создать водителя'.toUpperCase() }}
                    </v-card-title>
                    <v-text-field v-model='driver.Name' outlined dense label='Имя' />
                    <v-btn @click='saveDriver(driver,dialog)' color='primary' class='mr-2'>Добавить</v-btn>
                    <v-btn text @click='dialog.value = false'>Закрыть</v-btn>
                  </v-card-text>
                </v-card>
              </template>
            </oil-modal>
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:Vehicle.Trailer1='{input}'>
        <v-text-field
            v-model='waybill.Trailer1'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Прицеп №1'
            outlined
            dense
        />
      </template>
      <template v-slot:Vehicle.Trailer2='{input}'>
        <v-text-field
            v-model='waybill.Trailer2'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Прицеп №2'
            outlined
            dense
        />
      </template>
      <template v-slot:Convoy='{input}'>
        <v-text-field
            v-model='waybill.Convoy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Сопровождающий'
            outlined
            dense
        />
      </template>
      <template v-slot:Carrier='{input}'>
        <v-text-field
            v-model='waybill.Carrier'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Перевозчик'
            outlined
            dense
        />
      </template>
      <template v-slot:ShipmentDoneBy='{input}'>
        <v-text-field
            v-model='waybill.ShipmentDoneBy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Отпуск произвел'
            outlined
            dense
        />
      </template>
      <template v-slot:ShipmentAllowedBy='{input}'>
        <v-text-field
            v-model='waybill.ShipmentAllowedBy'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Отпуск разрешил'
            outlined
            dense
        />
      </template>
      <template v-slot:WaybillNote='{input}'>
        <v-text-field
            v-model='waybill.WaybillNote'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Путевой лист'
            outlined
            dense
        />
      </template>
      <template v-slot:Seals='{input}'>
        <v-text-field
            v-model='waybill.Seals'
            :class="waybill.NoTransport ? 'transport' : ''"
            :disabled='!input.isEdit'
            label='Пломбы'
            outlined
            dense
        />
      </template>

      <!--    Пункт погрузки     -->

      <template v-slot:Terminal.Id='{input}'>
        <div class='parent'>
          <v-autocomplete
              v-model='waybill.Terminal'
              :items='terminals'
              :disabled='!input.isEdit'
              clearable
              @change='changeTerminal'
              dense
              outlined
              hide-selected
              item-value='Id'
              item-text='Name'
              label='Пункт погрузки'
              return-object
          />
          <v-checkbox
              class='absolute'
              :disabled='!input.isEdit'
              v-model='waybill.TerminalShow'
              hide-details
              outlined
              dense
          />
        </div>
      </template>
      <template v-slot:Product='{input}'>
        <OilProduct
            :input='input'
            :contract='waybill.Contract'
            :item='waybill.Item'
        />
      </template>
    </oil-form>
  </div>
</template>

<script>


//services
import { companiesService } from '@/services/CompaniesService.js'
import { contractsService } from '@/services/ContractsService.js'
import { waybillService } from '@/services/WayBillService'
import { vehicleService } from '@/services/VehicleService'


import { ProductCalc } from '@/utils/functions/Product'
import Waybill from './model/waybill'
import update from './globalFunctionsInThisDirectory.js'
import { driverService } from '~/services/DriverSerivce'

export default {
  data() {
    return {
      readonlySeller: false,
      readonlyContract: false,
      readonlyProgram: false,
      readonlyProcuration: false,
      readonlyOrder: false
    }
  },
  mixins: [update],
  props: {
    id: {
      type: String,
      required: true
    }
  },


  methods: {
    async formCallback(waybill, input) {

      input.isEdit = false
      const item = waybill.Item

      const liter = parseFloat(item.AmountInLitre)
      const volume = parseFloat(waybill.Vehicle.Volume)

      if (isNaN(liter) && isNaN(volume)) {
        this.$notify({
          group: 'mgs',
          type: 'error',
          title: `некорректные данные`
        })
        input.isEdit = true
        return
      }
      waybill.TotalExcise = ProductCalc.TotalExcise(item)
      waybill.VAT = ProductCalc.TotalNds(item)
      waybill.NetTotal = ProductCalc.PriceClearTons(item)
      waybill.TotalNproductsoVat = ProductCalc.PriceClearNdsPrices(item)
      waybill.TotalPriceInText = item.TotalPriceInText
      waybill.Total = ProductCalc.TotalPrice(item)
      waybill.TotalNoVat = ProductCalc.PriceClearNdsPrices(item)
      waybill.Item.NetPricePerTonne = ProductCalc.PriceClearNdsPrice(item)
      const response = await waybillService.update(waybill)

      const id = response.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }
      this.openPdf(id, 'waybill/print')
    }
  },
  async created() {

    this.reset()
    this.keys['Appendix.Id'].attrs.readonly = false
    this.keys['Empowerment.Id'].attrs.readonly = false
    this.keys['Order.Id'].attrs.readonly = false

    this.waybill = new Waybill().wayBill
    const companies = await companiesService.getAll()
    const vehicles = await vehicleService.getAll({ isOwn: true })
    this.driverKey.VehicleId.attrs.items = vehicles.data
    this.vehicles$ = vehicles.data || []

    this.buyers = companies.data

    const response = await waybillService.getById(this.id)

    const waybill = response.data

    this.waybill = waybill


    console.log(response.data.NoTransport)
    const vehicle = waybill.Vehicle
    const driver = waybill.Driver
    const id = vehicle?.Id

    if (id) {
      const resp = await vehicleService.getById({ id: id, isOwn: true })
      await this.changeVehicle(resp.data)
    }

    // if (idD) {
    //   const respD = await driverService.getById({ id: idD})
    //   await this.changeDriver(respD.data)
    //   console.log(respD.data)
    // }


    if (vehicle) {
      this.vehicles$?.push(vehicle)
    }

    if (driver) {
      this.drivers$?.push(driver)
    }

    const buyerId = waybill.Buyer.Id

    const contracts = await contractsService.contractCompanyById({ companyId: buyerId })

    this.contracts = contracts.data

    const contract = this.contracts.find(({ Id }) => Id === waybill.Contract.Id)

    await this.changeBuyer(contract.Buyer)

    await this.changeContract(contract)

    const buyer = waybill.Buyer
    const HasPrivelege = buyer.HasPrivelege
    this.waybill.Item.tmpExcise = HasPrivelege === true ? 0 : this.waybill.Item.Excise

    const seller = await companiesService.seller()
    const {
      CompanyName,
      Address
    } = seller.data

    this.waybill.Terminal = this.waybill.Terminal || {}
    this.waybill.Vehicle = this.waybill.Vehicle || {}
    this.waybill.Driver = this.waybill.Driver || {}
    this.drivers$ = this.drivers$ || []


    if (this.waybill.Buyer) {
      this.readonlySeller = true
    }
    if (this.waybill.Contract) {
      this.readonlyContract = true
    }
    if (this.waybill.Appendix?.Id) {
      this.readonlyProgram = true
    }
    if (this.waybill.Empowerment) {
      this.readonlyProcuration = true
    }
    if (this.waybill.Order) {
      this.readonlyOrder = true
    }


    this.loading = true
  }
}
</script>

<style>


.parent {
  position: relative;
}

.absolute {
  position: absolute;
  left: 100%;
  right: 0;
  top: -12px;
}
.transport {
  display: none !important;
}
</style>